import { render, staticRenderFns } from "./modal-container.vue?vue&type=template&id=d5256d86"
import script from "./modal-container.vue?vue&type=script&lang=ts&setup=true"
export * from "./modal-container.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports